<p-toast></p-toast>

<div id="mySkillAcknowledgementPanelList">
    <div class="mySkillPanelList">
        <app-panel-list [showLoader]="showLoader" [panelList]="skillAcknowledgementPanelList" [noResultFound]="noData"
            [ifAdditionalItems]="true" [isExportButtonAvailable]="false" (selectedItems)="getSelectedItems($event)">

            <span class="additional-items">
                <p-checkbox class="show-all-checkbox" name="showAllSkills" value="all" *ngIf="isShowCheckbox === true"
                    [(ngModel)]="selectCheckbox" [binary]="true" (onChange)="checkboxSelectionChange()">
                </p-checkbox>

                <label *ngIf="enableInactiveLabel">
                    {{ checkboxLabel }}
                </label>

                <i *ngIf="showInformationIconCheckbox === true" class="fa fa-info-circle ml-2 info-icon-color"
                    aria-hidden="true" pTooltip="{{ informationIconTooltip }}">
                </i>
            </span>

            <ng-template #templateRef let-data="dataVar">
                <div class="card">
                    <div class="card-container">
                        <div class="flex">
                            <div class="skill-column overflow-ellipse flex-initial">
                                <app-label labelText="Skill"></app-label>
                                <div class="overflow-ellipse flex skill-header font-semibold">
                                    <div pTooltip="{{ data.skillCode }} {{ data.skillName }}">
                                        <a class="underline blue-color cursor-pointer"
                                            (click)="viewSkillDetails(data.skillCode)">
                                            {{ data.skillCode }} {{ data.skillName }}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="status-column">
                                <app-label labelText="Status"></app-label>
                                <div class="skill-status icon-alignment">
                                    <b>
                                        <i class="pi pi-circle-fill" [ngClass]="getStatusColor(data.status)">
                                        </i>
                                    </b>
                                    &nbsp;

                                    <div class="iconAlignment">
                                        {{ displayStatus(data.status) }}
                                        <span *ngIf="data.date">
                                            ({{ data.date | date: 'dd-MMM-yyyy' }})
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-panel-list>
    <app-spinner *ngIf="showLoader"></app-spinner>
    </div>

    <div class="btnClass" *ngIf="skillAcknowledgementPanelList?.lists?.length > 0">
        <p-button appPreventDoubleClick label="Acknowledge" id="acknowledgeSkillButton" class="acknowledge-button"
            iconPos="left" [disabled]="isAcknowledgeBtnDisable" (debounceClick)="acknowledgeSkills()">
        </p-button>
    </div>
</div>